export const GET_ARRANGEMENTEN = 'GET_ARRANGEMENTEN';
export const ADD_ARRANGEMENTEN = 'ADD_ARRANGEMENTEN';
export const SET_ARRANGEMENTEN = 'SET_ARRANGEMENTEN';
export const ERROR_ARRANGEMENTEN = 'ERROR_ARRANGEMENTEN';

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}


export function add(results) {
  return {
    type: ADD_ARRANGEMENTEN,
    results
  }
}
export function get(results) {
  return {
    type: GET_ARRANGEMENTEN,
    results
  }
}
export function set(results) {
  return {
    type: SET_ARRANGEMENTEN,
    results
  }
}
export function arrangementenError(error) {
  return {
    type: ERROR_ARRANGEMENTEN,
    payload: error
  };
}
export function Save(data) {
  return dispatch => {
    return fetch('/api/items/arrangementen', {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem('token')
        }
      }).then(handleResponse).then(results => {
        dispatch(add(results.results));
        return results;
      }).catch((err) => {
        dispatch(arrangementenError(err));
      });
    };
  }

  export function Update(data, id) {
    return dispatch => {
      return fetch('/api/items/arrangementen/'+id, {
          method: 'post',
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem('token')
          }
        }).then(handleResponse).then(results => {
          dispatch(add(results.results));
          return results;
        }).catch((err) => {
          dispatch(arrangementenError(err));
        });
      };
    }

export function Fetcharrangementen() {
  return dispatch => {
    fetch('/api/items/arrangementen', {
        method: 'get',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(data => dispatch(get(data.results)))
      .catch(err =>
        dispatch(arrangementenError(err)));
  };
}

export function GetArrangementen(id) {
  return dispatch => {
    return fetch('/api/items/arrangementen/'+id, {
        method: 'get',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(data => dispatch(set(data.results)))
      .catch(err =>
        dispatch(arrangementenError(err)));
  };
}
export function DeleteArrangementen(id) {
  return dispatch => {
    return fetch('/api/items/arrangementen/'+id, {
        method: 'delete',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(data => dispatch(set(data.results)))
      .catch(err =>
        dispatch(arrangementenError(err)));
  };
}

export function SetArrangemententoEdit(data) {
  return dispatch => {
    dispatch(set(data));
  }
};
